<div class="sitemap-grid">
  <div class="sitemap-grid__container">
    @for (section of sections; track section.title) {
      <div class="sitemap-grid__section">
        <h2>{{ section.title }}</h2>
        <ul class="sitemap-grid__links">
          @for (link of section.links; track link.url) {
            <li>
              @if (link.isExternal) {
                <a [href]="link.url" target="_blank" rel="noopener noreferrer" class="sitemap-grid__link">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9 18l6-6-6-6"/>
                  </svg>
                  {{ link.text }}
                </a>
              } @else {
                <a [routerLink]="link.url" class="sitemap-grid__link">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9 18l6-6-6-6"/>
                  </svg>
                  {{ link.text }}
                </a>
              }
            </li>
          }
        </ul>
      </div>
    }
  </div>
</div>
